module.exports = __webpack_public_path__ + "static/img/9.efacfd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/eng/9.png
// module id = e/oW
// module chunks = 0